/* eslint-disable react/no-unknown-property */
import { Box, Button, Paper, TextField, Typography } from '@mui/material'
import Image from 'next/image'
import React from 'react'
import { checkCouponElgible } from '../../redux/slices/common'
import { useDispatch, useSelector } from 'react-redux'
import { useState, useEffect } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import calculateDiscount from '../../components/Discounts/discount'

function Index({
  setGetDetails,
  getDetails,
  vendorId,
  price,
  packageId,
  serviceId,
  adultCount,
  childCount,
  seniorCount,
  adultAmt,
  childAmt,
  seniorAmt,
  defaultNights,
  roomCount,
  totalNights,
  defaultPrice
}) {
  const dispatch = useDispatch()
  const { couponDetails, error } = useSelector(state => state.common)
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [totalPay, setTotalPay] = useState(price)
  const [discountAmount, setDiscountAmount] = useState(0)
  const [currency, setCurrency] = useState('AED') // Default currency

  const userId = JSON.parse(sessionStorage.getItem('rslkey'))
  const handleApply = data => {
    const reqData = {
      userId: userId,
      promoCode: code,
      serviceType: serviceId,
      room_count: serviceId === 4 || serviceId === 8 ? parseInt(roomCount) : 0,
      night_count:
        serviceId === 4 || serviceId === 8 ? parseInt(totalNights) : 0,
      default_night_count:
        serviceId === 4 || serviceId === 8 ? parseInt(defaultNights) : 0,
      package_amount:
        serviceId === 4 || serviceId === 8 ? parseInt(defaultPrice) : 0,
      adult_count: serviceId === 6 ? parseInt(adultCount) : 0,
      child_count: serviceId === 6 ? parseInt(childCount) : 0,
      senior_count: serviceId === 6 ? parseInt(seniorCount) : 0,
      adult_price: serviceId === 6 ? parseInt(adultAmt) : 0,
      child_price: serviceId === 6 ? parseInt(childAmt) : 0,
      senior_price: serviceId === 6 ? parseInt(seniorAmt) : 0,
      services_id: packageId
    }

    setLoading(true)
    setGetDetails(null)
    const timer = setTimeout(() => {
      dispatch(checkCouponElgible(reqData))
    }, 500)

    return () => clearTimeout(timer) // Cleanup function to prevent memory leaks
  }

  const handleFiled = e => {
    let { value } = e.target
    let trimmedValue = value.trim().toUpperCase()

    if (trimmedValue.length >= 0) {
      setCode(trimmedValue)
    }
  }

  useEffect(() => {
    if (couponDetails?.status === 1) {
      setGetDetails(couponDetails)
      setLoading(false)
    } else {
      setGetDetails(couponDetails)
      setLoading(false)
    }
  }, [couponDetails])

  useEffect(() => {
    if (error?.response?.data?.status === -1) {
      setGetDetails(error?.response?.data)
      setLoading(false)
    }
  }, [error])

  useEffect(() => {
    const { discountAmount, totalPay } = calculateDiscount(price, getDetails)
    setDiscountAmount(discountAmount)
    setTotalPay(totalPay)
  }, [getDetails, price])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedCurrency = JSON.parse(
        sessionStorage.getItem('currency')
      )?.value
      if (storedCurrency) setCurrency(storedCurrency.toUpperCase())
    }
  }, [])

  return (
    <Paper
      elevation={0}
      className='border'
      sx={{
        padding: 2
      }}
    >
      {getDetails?.status === 1 ? (
        <div>
          <div className='grid justify-center w-full'>
            <div className='coupon-container'>
              <h2 className='fw-bold text-success'>Applied Successfulty</h2>
              <div className='coupon-status'>
                <div
                  className='checkmark'
                  style={{
                    color: '#6dc8bf'
                  }}
                >
                  &#10004;
                  <span className='px-2'>
                    {' '}
                    <p className='coupon-code'>{code}</p>
                  </span>
                </div>

                <p className='savings'>
                  You saved{' '}
                  <span style={{ color: '#6dc8bf' }}>
                    {discountAmount !== '-'
                      ? `${currency} ${discountAmount}`
                      : ''}
                  </span>
                </p>
                <button
                  style={{
                    border: '1px solid #6dc8bf',
                    color: '#6dc8bf',
                    backgroundColor: 'transparent',
                    padding: '4px 8px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={e => {
                    e.target.style.backgroundColor = '#6dc8bf'
                    e.target.style.color = 'white'
                  }}
                  onMouseOut={e => {
                    e.target.style.backgroundColor = 'transparent'
                    e.target.style.color = '#6dc8bf'
                  }}
                  onClick={() => {
                    setCode('')
                    setLoading(false)
                    setGetDetails({})
                  }}
                >
                  Change code
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <Box
            sx={{
              mb: 2
            }}
          >
            <Typography className='fw-bold' variant='h5'>
              Discounts
            </Typography>
          </Box>
          <Box
            className='d-flex flex-column flex-md-row align-items-center gap-2'
            sx={{ width: '100%' }}
          >
            <Box className='d-flex align-items-center w-100' sx={{ flex: 1 }}>
              <Image
                height='30'
                width='30'
                alt='promo'
                // src="/img/offerscards/coupon.png"
                src='/img/general/Coupen.svg'
                className='me-2'
              />

              {/* <TextField
                placeholder="CODE"
                label="Apply a promo code"
                size="small"
                value={code}
                onChange={handleFiled}
                style={{
                  width: "100%"
                }}
              /> */}
              <TextField
                placeholder='CODE'
                label='Apply a promo code'
                size='small'
                value={code}
                onChange={handleFiled}
                error={getDetails?.message}
                // helperText={getDetails?.message}
                inputProps={{ maxLength: 12 }} // Set maxLength here
                sx={{
                  width: '100%',
                  '& label': { color: '#697488' }, // Label color
                  '& label.Mui-focused': { color: '#697488' }, // Label color when focused
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: '#dddddd' }, // Default border color
                    '&:hover fieldset': { borderColor: '#dddddd' }, // Border color on hover
                    '&.Mui-focused fieldset': { borderColor: '#dddddd' } // Border color when focused
                  }
                }}
              />
            </Box>
            {/* <Box>
              {getDetails?.status === -1 ? (
                <p
                  style={{
                    fontSize: "10px",

                  }}
                  className="fw-bold text-danger invalid-promocode"
                >
                  {getDetails?.message}
                </p>
              ) : getDetails?.status === 1 ? (
                <p
                  style={{
                    fontSize: "10px",

                  }}
                  className="fw-bold text-danger invalid-promocode"
                >
                  {getDetails?.message}
                </p>
              ) : (
                ""
              )}
            </Box> */}
            {loading ? (
              <Button className='button h-30 text-white -dark-4 bg-dark-3 text-white'>
                <CircularProgress
                  sx={{
                    color: 'white'
                  }}
                  size='small'
                />
              </Button>
            ) : (
              <Button
                className='button h-30 px-20 text-white -dark-4 px-20 bg-dark-3 text-white'
                onClick={handleApply}
                disabled={!code}
              >
                Apply
              </Button>
            )}
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            {getDetails?.status === -1 ? (
              <p
                style={{
                  fontSize: '10px'
                }}
                className='fw-bold text-danger invalid-promocode'
              >
                {getDetails?.message}
              </p>
            ) : getDetails?.status === 1 ? (
              <p
                style={{
                  fontSize: '10px'
                }}
                className='fw-bold text-danger invalid-promocode'
              >
                {getDetails?.message}
              </p>
            ) : (
              ''
            )}
          </Box>
        </div>
      )}
    </Paper>
  )
}

export default Index
